import React from 'react';
import { useGlobal, getGlobal } from 'reactn';
import { Route, Switch, Redirect, useLocation } from 'react-router';
import Signin from '../../components/auth/Signin';
import Signup from '../../components/auth/Signup';
import ForgotCredentials from '../../components/auth/ForgotCredentials';
import EditCredentials from '../../components/auth/EditCredentials';
import EmailVerification from '../../components/auth/EmailVerification';
import ForgotPasswordEmailVerification from '../../components/auth/ForgotPasswordEmailVerification';
import backgroundImageUrl from '../assets/MCWA_Dashboard_HeroImage.jpg';

const Layout = () => {
  const { jwt } = getGlobal();
  const [userId, setUserId] = useGlobal('userId');
  const location = useLocation();

  if (jwt) {
    if (!userId) {
      setUserId(jwt.id);
    }

    return (
      <Redirect
        to={
          location.state?.from?.pathname + location.state?.from?.search ||
          '/user/dashboard'
        }
      />
    );
  }

  return (
    <div
      className="min-h-screen flex lg:items-center lg:justify-center"
      style={{
        background: backgroundImageUrl
          ? `url(${backgroundImageUrl}) no-repeat center center`
          : null,
        backgroundSize: 'cover',
      }}
    >
      <Switch>
        <Route path="/auth/signin" exact component={Signin} />
        <Route path="/auth/signup" exact component={Signup} />
        <Route
          path="/auth/forgot-credentials"
          exact
          component={ForgotCredentials}
        />
        <Route
          path="/auth/edit-credentials/:token"
          exact
          component={EditCredentials}
        />
        <Route
          path="/auth/forgot-credentials/:token"
          exact
          component={ForgotPasswordEmailVerification}
        />
        <Route
          path="/auth/email-verification/:token"
          component={EmailVerification}
        />
      </Switch>
    </div>
  );
};

export default Layout;
